<template>
  <div role="document" :class="documentLevelClass" :data-jest-content="document.id" v-if="document.description || document.subDocuments" :data-level="level" @click="handleClicks">
    <div
      class="document-container"
      :class="[parentHeaderStyle,labelClasses,stateClasses]"    
    >
      <div class="symbol v-icon" :class="icon" @click="toggleChildren($event)">
        <div class="icon-wrapper">
          <font-awesome-icon icon="plus" v-if="(!showChildren && !inShare)" class="v-icon"/>
          <font-awesome-icon icon="minus" v-if="(showChildren || inShare)" class="v-icon"/>
        </div>
      </div>
      <div :ref="'title'+document.id" @mouseenter="showHoverMenu" @mouseleave="showHoverMenu" class="text document-title v-title" @click="toggleChildren($event)">
        {{ document.version }} <span class="v-title" v-html="document.title"></span>
        <span v-if="level > 1" class="d-none hover-print badge badge-pill badge-secondary" @click.prevent="printPreview(document.id)">Print preview</span>
        <span v-html="selectedForPrint?'Deselect from print':'Select to print'" 
        class="d-none hover-print print-selector badge badge-pill badge-secondary" @click.prevent.self="selectToPrint(document)">
          
        </span>
      </div>
      
    </div>
    <div class="document-body indent" v-if="document.description && (showChildren || inShare)">
        <div v-if="document.description" v-html="document.description"></div>
    </div>
    
    <div role="group" v-if="showChildren || inShare" class="document-content children">
      <ByLawContent
        v-for="content in subDocuments"
        :key="content.id"
        :document="content"
        :subDocuments="content.subDocuments"
        :level="level + 1"
        :propagate="propagate"
        @clicked="emitToParent"
        @addToPrint="selectToPrint"       
      />
    </div>
  </div>
</template>


<script>
import ByLawContent from "@/components/ByLawContent";
import  "@/assets/sass/documentviewer.scss";
import { mapGetters } from "vuex";

export default {
  name: "ByLawContent",
  components: {
    ByLawContent
  },
  props: {
    document: Object,
    subDocuments: Array,
    level: Number,
    parentHeaderStyle: String,
    propagate: Boolean
  },
  data() {
    return {
      showChildren: false,
      selectedForPrint: false
    };
  },  
  computed: {
    ...mapGetters("viewer", ["getDefinitions","getDefinitionStatus"]),
    icon() {
      return {
        plus: !this.showChildren,
        minus: this.showChildren
      };
    },
    documentLevelClass() {
      return {
        "izbl-part": this.level == 0,
        indent: this.level > 0
      };
    },
    labelClasses() {
      return {
        "has-content": this.document.description?.trim().length > 0 || ( this.subDocuments?.length > 0)
      };
    },
    stateClasses() {
      return {
        collapsed: !this.showChildren,
        expanded: this.showChildren
      };
    },
    isLastLevel: function(){
      return this.subDocuments == null || this.subDocuments.length == 0;
    },
    inShare: function(){
      if(this.$route.name == "share"){
        var ids = this.$route.params.showItems.split(",");
        const index = ids.indexOf(this.document.id.toString());
        if(index > -1){
          this.showChildren = true;     
          this.$ga.page(`/show/${this.document.title?.replace(/<b>/gi,"").replace(/<\/b>/gi,"")}`);     
          return true;
        } else{
          this.showChildren = false;
          return false;
        }
      }
      
    }
  },
  mounted() {
    this.showChildren = !(this.document.title?.length > 0);
    if(this.propagate) //override default behavior
    {
      this.showChildren = this.propagate;
    }
    
     if(this.inShare){ // scroll to view the last component in url
       var ids = this.$route.params.showItems.split(",");
        if(ids.indexOf(this.document.id.toString()) == ids.length -1){ 
            this.$el.scrollIntoView({ behavior: 'smooth' });
        }
     }

      if(this.document.description){ // when clicked expand all
          var self = this;
          this.attachDefinitionEventListener();
          this.$nextTick(() => this.$nextTick(self.attachDefinitionEventListener()));
          this.$nextTick(() => this.$nextTick(self.resizeImage()));
      }
     
     

  },
  methods: {
    showHoverMenu(event){
      let { target } = event;
      let printSpan = target.children[1];
      let printQSpan = target.children[2];
      if(printSpan != null){
        printSpan.classList.toggle('d-none');
      }
       if(printQSpan != null){
        printQSpan.classList.toggle('d-none');
      }
    },
    printPreview(id){
       let ids = id; 
       if(this.subDocuments != null){
         ids += ","+ this.subDocuments.map(entity => entity.id); 
       }
      
       let routeData = this.$router.resolve({       
        path: "/search-print/"+ids
      }); 

       window.open(routeData.href, "_blank", "width=1000&location=no&scrollBar=yes");
    },
    selectToPrint(content){  
      let listOfIds = [];
      if(typeof content == "object"){
        listOfIds.push(content.id);
        this.selectedForPrint = !this.selectedForPrint;         
        if(content.subDocuments != null){
         let subContents = content.subDocuments.map(entity => entity.id); 
         subContents.forEach(sc => {
          listOfIds.push(sc);
         });
        }
       } else {
         listOfIds.push(content);
       }

       listOfIds.forEach(x => {         
        this.$refs["title"+x]?.classList.toggle("print-selection");      
        this.$emit("addToPrint",x);
       });
    },
    attachDefinitionEventListener(){
        var definitionlinks = this.$el.querySelectorAll('a[ref="defn"]');

        var self = this;
        if(definitionlinks){
          definitionlinks.forEach(elem => {
             if(!elem.classList.contains("bylaw-tooltip")){
              elem.addEventListener("mouseenter",self.showDefinition);  
              elem.setAttribute("class", "bylaw-tooltip"); 
             }
          });
        }
    },
    resizeImage(){
      var self = this;
      var images =  this.$el.querySelectorAll('img');
      images.forEach(elem => {
            if(!elem.classList.contains("zoom-in")){
              elem.setAttribute("class", "zoom-in"); 
              elem.setAttribute("title", "click to enlarge"); 
              elem.addEventListener("click",self.showLargeImage); 
            }
        });
    },
     handleClicks (event) {
      let { target } = event;
      
      if (target && target.tagName == 'A') {
        let linkTarget = target.getAttribute('href');
        if(linkTarget.indexOf("councildecisions.mississauga.ca") > 0){
          event.preventDefault();
          linkTarget = linkTarget.replace("http://councildecisions.mississauga.ca/","").replace("%20"," ");
          this.$fire({
            title: "Contact City",
            html: "Please email <a href='mailto:ScottT.Anderson@mississauga.ca?subject=Request%20for%20" + linkTarget+"'>City Clerk</a> for a copy of '"+linkTarget+"' by-law. ",
            type: "warning",
            timer: 10000
          }).then(r => {
          console.log(r.value);
          });
        }
        
      }
     },    
    showDefinition(event){     
      var title = event.target.getAttribute('data-title'); 
      if(title==null){
        var key = event.target.getAttribute('data-def');
        var def = this.getDefinitions.filter(d => d.term.toLowerCase() === key.toLowerCase());
        if(def.length > 0){
          event.target.setAttribute("data-title", "set");
          var titleNode = document.createElement("div"); 
          titleNode.innerHTML = def[0].definition;
          titleNode.className = "helptext";
          event.target.appendChild(titleNode); 
        } else {
          event.target.className = "";
        }
        
      }
    },
    emitToParent(){
      this.$emit('clicked');
    },
    toggleChildren(event) { 
      let { target } = event;
      if(target.classList.contains('v-title') || target.classList.contains('v-icon')){
        if(this.$route.name == "share"){
          var ids = this.$route.params.showItems.split(",");          
          var routeChanged = false;
          if(ids[0] === "all"){
            ids.splice(0,1);
            routeChanged = true;
          }
          const index = ids.indexOf(this.document.id.toString());
          if(index > -1){
            ids.splice(index,1);
            routeChanged = true;
          }
          else{
            if(!this.showChildren){
              this.$ga.page(`/show/${this.document.title?.replace(/<b>/gi,"").replace(/<\/b>/gi,"")}`);
              ids.push(this.document.id);
              routeChanged = true;
              }
          }
          if(routeChanged){
            this.$router.replace({ name: "share", params: {showItems:ids.join(",")} })
          }
        }else{
          this.$ga.page(`/show/${this.document.title?.replace(/<b>/gi,"").replace(/<\/b>/gi,"")}`);
          this.$router.push({path:'/show/'+this.document.id});
        }      
          this.emitToParent();
          this.showChildren = !this.showChildren;
          var self = this;
          if(this.showChildren){ //when openned by accordion
            this.$nextTick(() => this.$nextTick(self.attachDefinitionEventListener()));
            this.$nextTick(() => this.$nextTick(self.resizeImage()));
          }
       }
      
    },
    showLargeImage(event){      
      var src = event.target.getAttribute('src'); 
      if(src!=null){
        window.open(src);   
        return false;     
      }
    }
  },
  watch: {
    '$route.query.reset': function (newvalue) {
      this.showChildren = false;
    },
    '$route.query.refined': function (newvalue) {
      this.showChildren = false;
    },
    '$route' (to, from) {
      if(to.name !== from.name){
        this.showChildren = false;
      }
      
    }
  }
};
</script>
